import React from 'react'
// @ts-ignore no types
import { Icon, Text } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import { getFieldConfig, formatTimestamp } from './utils'
// @ts-ignore no types
import cls from './styles.scss'
import type { PropertyHistoryChange } from 'common/providers/propertyHistory'

const cx = classnames.bind(cls)

const HistoryItem = ({ change }: { change: PropertyHistoryChange }) => {
  const config = getFieldConfig(change.field)
  if (!config) return null

  const elmId = `property_history_${change.field.replace(/[./]/g, '_')}`

  return (
    <div className={cx('history-item')} data-elm-id={elmId}>
      <div className={cx('icon-wrap')}>
        <Icon name='calendar outline' />
      </div>
      <div className={cx('body')}>
        <Text weight='heavy' color='grayDark' data-elm-id={`${elmId}_title`}>
          {config.title}
        </Text>
        <div className={cx('change')}>
          <span className={cx('old')}>
            {config.format(change.previous_value)}
          </span>
          <span className={cx('arrow')}>→</span>
          <span className={cx('new')}>
            {config.format(change.current_value)}
          </span>
        </div>
        <Text size='tiny' color='gray' className={cx('timestamp')}>
          {formatTimestamp(change.changed_at)}
        </Text>
      </div>
      <div className={cx('badge')} data-elm-id={`${elmId}_badge`}>
        <Text size='tiny' color='grayDark'>
          {config.badge}
        </Text>
      </div>
    </div>
  )
}

export default HistoryItem
